import {
  action,
  observable
  // runInAction
} from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { DbKey, WithDbId } from '../../../../../adl-gen/common/db';
import {
  // AppClient,
  UserGroup
  // UserGroupManager, UserGroupMember,
} from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { UserGroupListEntry } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { GroupData } from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { GroupUserChange, GroupUserQuizChange, UserGroupStore } from '../../../../stores';
import { FormMode, toastOptions } from '../../../common/form';
// import { errorHandler, okHandler } from "../../../common/editor";
import { UserGroupEditor } from '../../editors/usergroup-editor/usergroup-editor';

// tslint:disable-next-line: no-import-side-effect ordered-imports
import '../../../widgets/toast/toastify.css';
// import { UserGroupChange } from "src/admin/stores/new-datastore";

interface UserGroupFormProps {
  item?: UserGroupListEntry;
  // members?: UserGroupMember[];
  // managers?: UserGroupManager[];
  // toDelete?: WithDbId<AppUser>[];
  data: GroupData;
  store: UserGroupStore;
  // onCreate(item: AppClient): Promise<Auth0Client>;
  // onUpdate(item: WithDbId<AppClient>): Promise<Auth0Client>;
  // onDelete(a: DbKey<AppClient>[]): Promise<void>;
  mode?: FormMode;
  onCancel(): void;
  isOpen: boolean;
}

// TODO: generic
interface ItemState {
  newItem?: UserGroup;
  error?: Error;
  updatedItem?: UserGroup;
  deletedItems?: DbKey<UserGroup>[];
}

@observer
export class UserGroupForm extends React.Component<UserGroupFormProps> {
  @observable fieldState: ItemState = {};

  onCreate = async (
    item: UserGroup,
    groupUpdates: GroupUserChange[],
    userQuizUpdates: GroupUserQuizChange[]
  ): Promise<void> => {
    const { onCancel, store } = this.props;

    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      const groupId = await store.create(item);

      await store.updateUserGroups(groupId, groupUpdates);
      await store.updateUserQuizzes(userQuizUpdates);

      toast.dismiss(toastId);
      toast.success(`Group ${item.name} created.`, { ...toastOptions, onClose: onCancel, autoClose: 3000 });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`User ${item.name} create failed: ${(e as Error).message}`, { ...toastOptions, onClose: onCancel });
    }
  };

  onUpdate = async (
    item: WithDbId<UserGroup>,
    groupUpdates: GroupUserChange[],
    userQuizUpdates: GroupUserQuizChange[]
  ) => {
    const { onCancel, store } = this.props;

    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      await store.update(item);

      await store.updateUserGroups(item.id, groupUpdates);
      await store.updateUserQuizzes(userQuizUpdates);

      toast.dismiss(toastId);
      toast.success(`Group ${item.value.name} updated.`, { ...toastOptions, onClose: onCancel, autoClose: 3000 });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`User ${item.value.name} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: onCancel
      });
    }
  };

  // onDeletes = async (a: DbKey<AppClient>[]) => {
  //   try {
  //     await this.props.onDelete(a);
  //     runInAction(() => (this.fieldState.deletedClients = a.slice()));
  //   } catch (e) {
  //     runInAction(() => (this.fieldState.error = e as Error));
  //   }
  // };

  @action
  onCancel = () => {
    this.props.onCancel();
  };

  renderContent = () => {
    const {
      item,
      data,
      // mode,
      store
      // toDelete,
    } = this.props;
    if (
      // mode === "update" &&
      item
    ) {
      return (
        <UserGroupEditor
          item={item}
          data={data}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
      /// TODO Delete
    } else {
      return (
        <UserGroupEditor
          data={data}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
        <ToastContainer newestOnTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/usergroup-form/usergroup-form.tsx